export function makeCanonicalUrl(host: string, zoneName?: string, tariff?: string): string {
  const prefix = /(http(s?)):\/\//i.test(host) ? '' : 'https://'
  const normalizedHost = host.replace(/\/+$/, '')

  // Формируем канонический URL по правиламы:
  // - express, ndd_self_pickup, ndd_shipment -> /order/
  // - cargo -> /order/cargo/[city?]/
  // - cargo_intercity:
  //   - /order/russia/cargo_intercity/ -> /order/cargo-intercity/
  //   - /order/cargo-intercity/[city]/ -> /order/cargo-intercity/[city]/
  // - walking_courier -> /order/[city?]/
  // - default:
  //   - /order/[city?]/

  let path = '/order/'

  switch (tariff) {
    case 'express':
    case 'ndd_self_pickup':
    case 'ndd_shipment': {
      path = '/order/'
      break
    }
    case 'cargo': {
      path = `/order/cargo/${zoneName ? `${zoneName}/` : ''}`
      break
    }
    case 'cargo_intercity': {
      const city = zoneName && zoneName !== 'russia' ? zoneName : undefined
      path = `/order/cargo_intercity/${city ? `${city}/` : ''}`
      break
    }
    case 'walking_courier':
    default: {
      path = `/order/${zoneName ? `${zoneName}/` : ''}`
    }
  }

  return `${prefix}${normalizedHost}${path}`
}
